import {
  useCurrentUploadQuery,
  useRemoveUploadMutation,
} from "@/hooks/uploads";
import Button from "@ingka/button";
import Modal, { ModalFooter, Prompt } from "@ingka/modal";
import { AxiosResponse } from "axios";
import { AssetDto } from "generated";
import { useNavigate } from "react-router";
import Text from "@ingka/text";

type Props = {
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
  removeAssetsUpload: () => Promise<AxiosResponse<AssetDto, unknown>>;
};

const AssetListModal = ({
  isModalOpen,
  setIsModalOpen,
  removeAssetsUpload,
}: Props) => {
  const navigate = useNavigate();
  const removeUploadMutation = useRemoveUploadMutation();
  const currentUploadQuery = useCurrentUploadQuery();

  const onRemoveAssetsUpload = async () => {
    const upload = currentUploadQuery.data;
    if (!upload) {
      return;
    }

    await removeAssetsUpload();
    await removeUploadMutation.mutateAsync(upload.id);

    navigate("/overview");
  };

  return (
    <Modal
      visible={isModalOpen}
      escapable={true}
      handleCloseBtn={() => setIsModalOpen(false)}
    >
      <Prompt
        title={<span className="mt-space100 block">Remove entire draft?</span>}
        titleId="delete-last-asset"
        header={null}
        footer={
          <ModalFooter>
            <Button
              text="No, keep draft"
              type="secondary"
              onClick={() => setIsModalOpen(false)}
            />
            <Button
              text="Yes, remove draft"
              type="primary"
              onClick={onRemoveAssetsUpload}
            />
          </ModalFooter>
        }
      >
        <Text tagName="p">
          Removing all files will result in the permanent deletion of your draft
          (including metadata). Are you sure you want to continue?
        </Text>
      </Prompt>
    </Modal>
  );
};

export default AssetListModal;
